import { render } from "./skeleton-modal-shipment-v3.vue?vue&type=template&id=57b62e46&ts=true"
import script from "./skeleton-modal-shipment-v3.vue?vue&type=script&lang=ts"
export * from "./skeleton-modal-shipment-v3.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__